export * from 'app/zdslogic-ui-shell/@fuse/components/fullscreen/fullscreen.component';
export * from 'app/zdslogic-ui-shell/@fuse/components/fullscreen/fullscreen.module';
export * from 'app/zdslogic-ui-shell/@fuse/components/fullscreen/fullscreen.types';
export * from 'app/zdslogic-ui-shell/@fuse/components/fullscreen/fullscreen.module';
